import { useEffect } from 'react'
import { templateManager } from '../components/Template/TemplateManager'
import { useAppStore } from '../store/appStore'
import { isReadOnly } from '../models/UserModel'

export const useTemplatesInit = () => {
    const userModel = useAppStore((state) => state.userModel)

    useEffect(() => {
        if (!userModel) return

        // Nothing is ever fetched for an offboarded user, so the flag has to be cleared here.
        // Left standing, it keeps every view that dims itself while templates load — the
        // encounter top panel among them — behind a spinner that never resolves (MD-1497).
        if (isReadOnly(userModel)) {
            useAppStore.setState({ templatesLoading: false })
            return
        }

        const fetchTemplates = async () => {
            await templateManager.fetchTemplates()
        }
        fetchTemplates()
    }, [userModel])
}
